export const GoalsList = [
  'Grow Wealth',
  'Protect/Preserve my investment',
  "Save for my children's education",
  'Save for my education',
  'Go on holiday',
  'Start a business',
  'Buy a house',
  'Buy a car',
  'Save for my wedding',
  'Save for emergencies',
];

export const AchieveByList = {
  weight: 20,
  types: [
    { desc: 'less than a year', points: 1 },
    { desc: 'between 1 and 2 years', points: 1 },
    { desc: 'between 2 and 3 years', points: 2 },
    { desc: 'between 4 and 5 years', points: 3 },
    { desc: '5 years plus', points: 4 },
  ],
};

export const NeedToWithdrawList = {
  weight: 5,
  types: [
    {
      desc: "No, I'm planning on withdrawing money whenever I want / need to.",
      points: 0,
    },
    { desc: "I'm not sure.", points: 1 },
    {
      desc: 'I think so, but it depends on if I need money for an emergency.',
      points: 1,
    },
    {
      desc: "I won't need the money, I have other savings I can use if need be.",
      points: 2,
    },
    {
      desc: "Yes, I'm not planning on withdrawing it. I want it to get maximum growth.",
      points: 3,
    },
  ],
};

export const NeedToWithdrawListRA = {
  weight: 10,
  warning:
    "You can't access the funds before age 55 (except in extraordinary circumstances). Please consider revising your product choice.",
  types: [
    {
      desc: "Yes, I'm planning on withdrawing money whenever I want / need to.",
      points: 0,
      warning: true,
    },
    { desc: "I'm not sure.", points: 1, warning: true },
    {
      desc: 'I don’t think so, but is depends on if I need money for an emergency.',
      points: 1,
      warning: true,
    },
    {
      desc: "I won't need the money, I have other savings I can use if need be.",
      points: 2,
    },
    {
      desc: "No, I'm not planning on withdrawing it. I want it to get maximum growth.",
      points: 3,
    },
  ],
};

export const NeedToWithdrawListTFSA = {
  weight: 0,
  warning:
    'Withdrawing from your Tax-Free Savings account can negatively impact your tax advantages. Consider revising your product choice. (e.g. Unit Trust)',
  types: [
    {
      desc: "No, I'm planning on withdrawing money whenever I want / need to.",
      points: 0,
      warning: true,
    },
    { desc: "I'm not sure.", points: 0, warning: true },
    {
      desc: 'I think so, but is depends on if I need money for an emergency.',
      points: 0,
      warning: true,
    },
    {
      desc: "I won't need the money, I have other savings I can use if need be.",
      points: 0,
    },
    {
      desc: "Yes, I'm not planning on withdrawing it. I want it to get maximum growth.",
      points: 0,
    },
  ],
};

export const RiskDescriptionsList = {
  weight: 5,
  types: [
    { desc: 'Danger', points: 1 },
    { desc: 'Caution', points: 2 },
    { desc: 'Uncertainty', points: 3 },
    { desc: 'Opportunity', points: 4 },
    { desc: 'Excitement', points: 5 },
  ],
};

export const RiskProfileTypes = {
  weight: 70,
  types: [
    {
      name: 'The Conservative Investor',
      points: 1,
      riskCategory: 'Conservative',
      withdrawing: 'I may need to withdraw from the investment WITHIN THE NEXT YEAR.',
      totalSavings:
        'I have ZERO or LITTLE alternative SAVINGS available for emergencies or other short-term financial needs.',
      investmentGoal:
        'PROTECT the amount I have invested, even if this may mean that returns could be close to inflation.',
      riskAppetite:
        'I would really not like to face the possibility of any capital losses. I prefer investments that offer STABLE growth and do not fluctuate much in value on a year-to-year basis.',
      portfolio:
        'My ideal portfolio is probably something with income & credit assets and little to no exposure to equities.',
    },
    {
      name: 'The Cautious Investor',
      points: 2,
      riskCategory: 'Cautious',
      withdrawing:
        'I may need to withdraw from the investment within the next 2-3 YEARS, but not before then.',
      totalSavings:
        'This investment makes-up most of my savings. I have LITTLE alternative SAVINGS available for emergencies or other short-term financial needs.',
      investmentGoal:
        'PROTECT and PRESERVE the investment, even if this may mean that returns are ±inflation +2% per annum over the period.',
      riskAppetite:
        'I prefer investments that offer STABLE growth, but I can accept SLIGHT FLUCTUATIONS in the value of my portfolio.',
      portfolio:
        'My ideal portfolio is something with a little more risk than a Conservative investor, holding income & credit assets, bonds, property and a little more exposure to equities.',
    },
    {
      name: 'The Moderate Investor',
      points: 3,
      riskCategory: 'Moderate',
      withdrawing:
        'I may need to withdraw from the investment in the next 4-5 YEARS, but not before then.',
      totalSavings:
        'I have SUFFICIENT ALTERNATIVE SAVINGS available for emergencies and other short-term financial needs.',
      investmentGoal: 'Achieve MODERATE CAPITAL GROWTH ±inflation + 4% p/ a over the period.',
      riskAppetite:
        'I understand that markets may fall over the short-term causing potential short-term losses. However, can tolerate a FAIR AMOUNT of FLUCTUATIONS in the value of my investment over the short- term, in anticipation of higher returns above inflation over time.',
      portfolio:
        'My ideal portfolio is holding multiple-asset types. Global and Local assets, 40-60% in equity, income & credit assets and property.',
    },
    {
      name: 'The Moderately Aggressive Investor',
      points: 4,
      riskCategory: 'Moderately Aggressive',
      withdrawing:
        'I am comfortable investing for a period of at least 5 YEARS and LONGER, not withdrawing before then.',
      totalSavings:
        'I have SUFFICIENT ALTERNATIVE SAVINGS available for emergencies and other short-term financial needs.',
      investmentGoal: 'Achieve FAIRLY HIGH CAPITAL GROWTH ±inflation + 6% p/a over the period.',
      riskAppetite:
        'I understand that markets may fall over the short-term causing potential short-term losses. However, I can tolerate FAIRLY HIGH FLUCTUATIONS in the value of my investment over the short- term, in anticipation of higher returns above inflation over time.',
      portfolio:
        'My ideal portfolio holds diversity across all assets, but with a bias towards equities holding anywhere between 60-80%. It serves the purpose of long-term investment growth. (Up to 75% for Retirement products with Regulation 28).',
    },
    {
      name: 'The Aggressive Investor',
      points: 5,
      riskCategory: 'Aggressive',
      withdrawing:
        'I am comfortable with investing for at least 5 YEARS and LONGER, not withdrawing before then.',
      totalSavings:
        'I have SUFFICIENT ALTERNATIVE SAVINGS available for emergencies and other short-term financial needs.',
      investmentGoal: 'Achieve FAIRLY HIGH CAPITAL GROWTH ±inflation + 7% p/a.',
      riskAppetite:
        'I understand that markets may fall in the short term and that my investment may experience potential short- term losses higher than in a moderate aggressive portfolio. I am able to tolerate the possibility of extreme fluctuations in the value of my investment over the short-term.',
      portfolio:
        'My ideal portfolio is something that holds a bit of diversity across all assets, but with a large bias towards equities. It must hold the maximum amount possible to maximising long-term investment growth.',
    },
  ],
};

export const TaxFreeRiskDescriptionsList = {
  weight: 10,
  types: [
    { desc: 'Danger', points: 1 },
    { desc: 'Caution', points: 2 },
    { desc: 'Uncertainty', points: 3 },
    { desc: 'Opportunity', points: 4 },
    { desc: 'Excitement', points: 5 },
  ],
};

export const TaxFreeRiskProfileTypes = {
  weight: 90,
  types: [
    {
      name: 'The Moderate Investor',
      points: 1,
      riskCategory: 'Moderate',
      withdrawing:
        'I may need to withdraw from the investment in the next 4-5 YEARS, but not before then.',
      totalSavings:
        'I have SUFFICIENT ALTERNATIVE SAVINGS available for emergencies and other short-term financial needs.',
      investmentGoal: 'Achieve MODERATE CAPITAL GROWTH ±inflation + 4% p/ a over the period.',
      riskAppetite:
        'I understand that markets may fall over the short-term causing potential short-term losses. However, can tolerate a FAIR AMOUNT of FLUCTUATIONS in the value of my investment over the short- term, in anticipation of higher returns above inflation over time.',
      portfolio:
        'My ideal portfolio is holding multiple-asset types. Global and Local assets, 40-60% in equity, income & credit assets and property.',
    },
    {
      name: 'The Moderately Aggressive Investor',
      points: 2,
      riskCategory: 'Moderately Aggressive',
      withdrawing:
        'I am comfortable investing for a period of at least 5 YEARS and LONGER, not withdrawing before then.',
      totalSavings:
        'I have SUFFICIENT ALTERNATIVE SAVINGS available for emergencies and other short-term financial needs.',
      investmentGoal: 'Achieve FAIRLY HIGH CAPITAL GROWTH ±inflation + 6% p/a over the period.',
      riskAppetite:
        'I understand that markets may fall over the short-term causing potential short-term losses. However, I can tolerate FAIRLY HIGH FLUCTUATIONS in the value of my investment over the short- term, in anticipation of higher returns above inflation over time.',
      portfolio:
        'My ideal portfolio holds diversity across all assets, but with a bias towards equities holding anywhere between 60-75%. It serves the purpose of long-term investment growth.',
    },
    {
      name: 'The Aggressive Investor',
      points: 3,
      riskCategory: 'Aggressive',
      withdrawing:
        'I am comfortable with investing for at least 7 YEARS and LONGER, not withdrawing before then.',
      totalSavings:
        'I have SUFFICIENT ALTERNATIVE SAVINGS available for emergencies and other short-term financial needs.',
      investmentGoal: 'Achieve FAIRLY HIGH CAPITAL GROWTH ±inflation + 7% p/a.',
      riskAppetite:
        'I understand that markets may fall in the short term and that my investment may experience potential short- term losses higher than in a moderate aggressive portfolio. I am able to tolerate the possibility of extreme fluctuations in the value of my investment over the short-term.',
      portfolio:
        'My ideal portfolio holds 100% in equities. It serves the purpose of long-term investment growth.',
    },
  ],
};

export const Vehicles = [
  {
    id: 1,
    description:
      'Invest to achieve my investment goals. ' +
      'Suitable for emergency funds, saving for a holiday, a home, education, starting a business etc. ',
    fundSelectHeading:
      'Unit Trusts are ideal vehicles to save for your lifestyle goals over the short, medium or long-term.',
    fundSelectDescription:
      'Your choice of an investment solution(s) / fund(s) should reflect the features of your investment goal: the time horizon you have available to achieve your goal(s) and the degree of risk you’re willing to take. Time and risk are connected, so you can take more risk investing over the long-term.',
    disable: false,
    minimums: { lumpsum: 50000, monthly: 1000 },
    name: 'Basic Investment',
    description1: 'Unit Trust',
    description2: 'achieve a specific goal',
    icon: 'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/invest+now+icons/Iconography_black_Target+achieved.png',
    formSections: [
      'contact_information',
      'personal_information',
      'investment_details',
      'banking_and_payment',
      'regular_withdrawals',
      'tax_details',
      'required_documents',
      'review_and_submit',
    ],
    actingOnBehalf: true,
    suitableFor:
      'Unit Trusts are ideal vehicles to save for your lifestyle goals over the short, medium or long term. (Such as emergency funds, saving for a holiday, a home, a car education, starting a business, growing wealth etc.)',
    benefits: [
      'Easy to start and manage, giving you control and flexibility. Debit Order and / or ad hoc contributions can be made. ',
      'Affordable and convenient.',
      'Customize your investment to suit your needs, financial circumstances and risk appetite.',
      'Choose from a variety of local and foreign asset classes, including equities, property, bonds and cash.',
      'Enjoy unrestricted access to your money - you can withdraw at any time.',
    ],
  },
  {
    id: 3,
    description:
      "I'm looking to grow my money in a flexible vehicle that provides tax-free returns, while allowing withdrawals. " +
      "I'm aware of the lifetime contribution limit of R500,000 and annual limit of R36,000. ",
    fundSelectHeading:
      'Tax-Free Savings Accounts are ideal long-term investments providing tax-free returns and other tax benefits.',
    fundSelectDescription:
      "Your choice of an investment solution(s) / fund(s) should reflect the features of your investment goal: the time horizon you have available to achieve your goal(s) and the degree of risk you're willing to take. Time and risk are connected, so you can take more risk investing over a long-term.",
    disable: false,
    minimums: {
      lumpsum: 10000,
      monthly: 500,
      //lumpsumMax: 36000,
      monthlyMax: 3000,
      additional:
        'Two contribution limits apply: R36,000 per annum and R500,000 over your lifetime, with 40% tax payable on the amount exceeding these limits.',
    },
    name: 'Tax-Free Savings Account',
    description1: 'Tax Free Savings',
    description2: 'invest tax- free',
    icon: 'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/invest+now+icons/Iconography_black_Fixed+income.png',
    formSections: [
      'contact_information',
      'personal_information',
      'investment_details',
      'banking_and_payment',
      'regular_withdrawals',
      'tax_details',
      'required_documents',
      'review_and_submit',
    ],
    actingOnBehalf: true,
    suitableFor:
      'Tax-Free Savings Accounts are ideal long-term investments that provide tax-free returns and other tax benefits. No tax is payable on interest, dividends or realised capital gains or losses. Any withdrawals are also tax-free.',
    benefits: [
      'Easy to start and manage, giving you control and flexibility. Debit Order and / or ad hoc contributions can be made.',
      'Affordable and convenient.',
      'Customize your investment to suit your needs, financial circumstances and risk appetite.',
      'Choose from a variety of local and foreign asset classes, including equities, property, bonds and cash.',
      'Enjoy unrestricted access to your money - you can withdraw at any time.',
      'No tax is payable on interest, dividends or realized capital gains or losses. Any withdrawals are also tax-free. This applies within the stated contribution limits.',
    ],
  },
  {
    id: 4,
    description:
      "I'm an investor, desiring to diversify my existing investment portfolio with alternative assets. I'm looking " +
      'to invest a minimum of R50,000 in a Retail Investor Hedge Fund.',
    fundSelectHeading:
      'A Retail Investor Hedge Fund (RIHF) is ideal if you want to invest in a fund that responds differently to market changes, compared to traditional asset classes.',
    fundSelectDescription:
      'Including this fund in your investment portfolio will provide broader diversification using more diverse alternative instruments, whilst aiming to achieve market-beating returns and gain performance possibly in falling markets.',

    disable: false,
    minimums: { lumpsum: 50000, monthly: 1000 },
    name: 'Retail Investor Hedge Fund',
    description1: 'Retail Investment Hedge Fund (RIHF)',
    description2: 'add alternative assets to my portfolio',
    icon: 'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/invest+now+icons/Iconography_black_Quantitive+risk+management.png',
    formSections: [
      'contact_information',
      'personal_information',
      'investment_details',
      'banking_and_payment',
      'regular_withdrawals',
      'tax_details',
      'required_documents',
      'review_and_submit',
    ],
    suitableFor:
      'A Retail Investor Hedge Fund (RIHF) is ideal if you want to invest in a fund that responds differently to market changes, compared to traditional asset classes. This provides your investment with broader diversification by using more diverse alternative asset classes and strategies.',
    benefits: [
      'Easy to start and manage, giving you control and flexibility. Debit Order and / or ad hoc contributions can be made.',
      'Affordable and convenient.',
      'Customize your investment to suit your needs, financial circumstances and risk appetite.',
      'Choose from a combination of local and foreign asset classes, including traditional (equities, property, bonds and cash) and alternative assets (directional equities, soft commodities, etc).',
      'Take advantage of unconventional opportunities in a diverse range of markets and generate investment returns uniquely.',
      'Unlock extraordinary investment strategies that generate and enhance investment returns in all market conditions, while simultaneously providing downside risk protection.',
      'Enjoy unrestricted access to your money - you can withdraw at any time.',
    ],
  },
  {
    id: 5,
    description:
      "I'm a high net worth investor, desiring to diversify my existing investment portfolio with alternative assets. I'm looking " +
      'to invest a minimum of R1,000,000 in a Qualified Investor Hedge Fund.',
    fundSelectHeading:
      'A Qualified Investor Hedge Fund (QIHF) is ideal if you want to invest in a fund that responds differently to market changes, compared to traditional asset classes.',
    fundSelectDescription:
      'Including this fund in your investment portfolio will provide broader diversification using more diverse alternative instruments, whilst aiming to achieve market-beating returns and possibly gain performance in falling markets.',
    disable: false,
    minimums: { lumpsum: 1000000, monthly: 0 },
    name: 'Qualified Investor Hedge Fund',
    description1: 'Qualified Investment Hedge Fund (QIHF)',
    description2: 'add a minimum of R1 million of alternative assets to my portfolio',
    icon: 'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/invest+now+icons/Iconography_black_Corporations.png',
    formSections: [
      'contact_information',
      'personal_information',
      'investment_details',
      'banking_and_payment',
      'regular_withdrawals',
      'tax_details',
      'required_documents',
      'review_and_submit',
    ],
    suitableFor:
      'A Qualified Investor Hedge Fund (RIHF) is ideal if you want to invest in a fund that responds differently to market changes, compared to traditional asset classes. This provides your investment with broader diversification by using more diverse alternative asset classes and strategies.',
    benefits: [
      'Easy to start and manage, giving you control and flexibility. Debit Order and / or ad hoc contributions can be made.',
      'Affordable and convenient.',
      'Customize your investment to suit your needs, financial circumstances and risk appetite.',
      'Choose from a combination of local and foreign asset classes, including traditional (equities, property, bonds and cash) and alternative assets (directional equities, soft commodities, etc).',
      'Take advantage of unconventional opportunities in a diverse range of markets and generate investment returns uniquely.',
      'Unlock extraordinary investment strategies that generate and enhance investment returns in all market conditions, while simultaneously providing downside risk protection.',
      'Enjoy unrestricted access to your money - you can withdraw at any time.',
    ],
  },
  {
    id: 2,
    description:
      'I want to invest towards my retirement, or supplement existing retirement funds, and would like to make the ' +
      'most of the tax benefits available to me.',
    fundSelectHeading:
      'Retirement Annuities are ideal vehicles to save for retirement in a tax efficient manner, as contributions can be deducted from tax to a certain extent.',
    fundSelectDescription:
      'No access to the funds before the age of 55 (except in extraordinary circumstances). At retirement, a maximum of one-third can be paid out to you as a cash lump sum, the remaining value must be used to purchase an annuity. If the value is less than R247,500, you may withdraw all of it.',
    disable: false,
    minimums: { lumpsum: 50000, monthly: 1000 },
    name: 'Retirement Annuity',
    description1: 'Retirement Annuity',
    description2: 'start saving for retirement',
    icon: 'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/invest+now+icons/Iconography_black_Retirement+plan.png',
    formSections: [
      'contact_information',
      'personal_information',
      'beneficiaries_nominations',
      'investment_details',
      'banking_and_payment',
      'tax_details',
      'required_documents',
      'review_and_submit',
    ],
    actingOnBehalf: false,
    suitableFor:
      'Retirement Annuities are ideal for saving toward retirement in a tax-efficient manner, as contributions are tax deductible. At retirement, a maximum of one-third of your investment balance can be paid out to you as a cash lump sum, the remaining value must be transferred to an annuity for income withdrawals. No withdrawals from the fund before the age of 55 can be made, unless the value is less than R247,500 or in extraordinary circumstances. ',
    benefits: [
      'Easy to start and manage, giving you control and flexibility. Debit Order and / or ad hoc contributions can be made.',
      'Affordable and convenient.',
      'Customize your investment to suit your needs, financial circumstances and risk appetite.',
      'Choose from a variety of local and foreign asset classes, including traditional (equities, property, bonds and cash) and alternative assets (directional equities, soft commodities, etc).',
      'Your contributions are tax-deductible (subject to legislative limits) and no tax on interest, capital gains or dividend withholding tax is levied within the product.',
      'At retirement, lumpsum withdrawals are taxed based on favourable retirement benefits tax tables.',
      'Your funds are protected against creditors in the event of insolvency.',
    ],
  },

  {
    id: 6,
    description:
      "I have accumulated retirement savings that I'm looking to protect and grow until I decide to retire.",
    disable: true,
    minimums: { lumpsum: 50000, monthly: 1000 },
    name: 'Preservation Fund',
    description1: 'Preservation Fund',
    description2: 'preserve existing retirement savings',
    icon: 'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/invest+now+icons/Iconography_black_Integrity.png',
    suitableFor:
      'Preservation Funds are ideal to preserve and grow existing retirement savings until you are ready to retire. It is a tax-efficient investment vehicle enabling you to preserve and grow your accumulated retirement savings upon exiting a pension or provident fund after leaving employment through retrenchment, resignation, or dismissal.',
    benefits: [
      'Transfers from a pension fund or provident fund into a preservation fund is tax-free.',
      'No tax on interest, capital gains or dividend withholding tax is levied within the product.',
      'Any lump sum withdrawals prior to or at retirement will be taxed according to favourable tax tables.',
      'Customize your investment to suit your needs, financial circumstances and risk appetite.',
      'Choose from a variety of local and foreign asset classes, including traditional (equities, property, bonds and cash) and alternative assets (directional equities, soft commodities, etc).',
      'Your funds are protected against creditors in the event of insolvency.',
      'Upon your death, the funds are payable to your financial dependents and / or nominated beneficiaries. Thus, it does not form part of your deceased estate and attracts no estate duty or executor fees.',
    ],
  },
  {
    id: 7,

    description:
      'I have accumulated retirement savings that I want to start drawing an income from. ',
    disable: true,
    minimums: { lumpsum: 50000, monthly: 1000 },
    name: 'Living Annuity',
    description1: 'Living Annuity',
    description2: 'draw income during retirement',
    icon: 'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/invest+now+icons/Iconography_black_Unit+trust.png',
    suitableFor:
      'Living Annuities are a post-retirement investment product, ideal for drawing an income from your existing retirement savings. This allows you to simultaneously invest and grow your accumulated retirement savings while drawing a regular income',
    benefits: [
      'Maximise your capital growth, increase investment longevity and sustain your income in retirement for as long as possible.',
      'Customise your investment portfolio to your specific needs, financial circumstance and risk appetite.',
      'No investment restrictions apply and you can invest in a variety of local and foreign asset classes, including traditional (equities, property, bonds and cash) and alternative assets (directional equities, soft commodities, etc.).',
      'All growth including interest income, dividend income and capital gains are free from tax. You will only pay tax, at your marginal tax rate, on your regular income withdrawals.',
      'You can choose how much income you want to withdrawal per annum, between 2.5% and 17.5%. The rate and frequency can be changed once a year.',
      'Upon your death, the proceeds are payable to your nominated beneficiaries and will not attract estate duty or executor fees.',
      'The capital within the living annuity is protected against creditors.',
    ],
  },
  {
    id: 8,

    description:
      "I'm looking to protect and grow my money in a tax efficient manner over the long term (5 years or more). " +
      'My marginal tax rate exceeds 30% and the investment vehicle should also provide estate planning advantages.',
    disable: true,
    minimums: { lumpsum: 50000, monthly: 1000 },
    name: 'Endowment',
    description1: 'Endowment',
    description2: 'limit my ability to withdraw within 5 years',
    icon: 'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/invest+now+icons/Iconography_black_Living+Annuity.png',
    suitableFor:
      'Endowments are ideal for investors looking to invest for a minimum of five years and want withdrawal restrictions. They are also suitable to investors who are taxed at marginal rates above 30%.',
    benefits: [
      'Affordable, easy to start and manage.',
      'Customize your investment to suit your needs, financial circumstances and risk appetite.',
      'Choose from a variety of local and foreign asset classes, including equities, property, bonds and cash.',
      'Your funds are protected against creditors after three years, in the event of insolvency (provided certain criteria are met).',
    ],
    withdrawalsAndContibutionRestrictions: [
      'Can make one restricted withdrawal and one restricted loan during the first five years.',
      'Debit Order and / or ad hoc contributions can be made. There are no restrictions on the amounts that can be contributed during the first year. From the second year, the maximum allowable contribution is 120% of the total contributions made in the first year (where applicable).',
    ],
  },
];

export const Funds = [
  // {
  //   id: 1,
  //   name: "Fairtree Flexible Income Plus Prescient Fund",
  //   vehicles: ["Basic Investment", "Tax-Free Savings Account"],
  //   time: "1-2 years",
  //   risk: "Conservative",
  //   assetHoldings: "Fixed Income / Bonds",
  //   regionalHoldings: "Local and Offshore",
  //   useForBasicInvestmentHelp: true,
  //   useForRetirementAnnuityHelp: {
  //     enable: true,
  //     minPoints: 0,
  //     maxPoints: 0.9,
  //   },
  //   minPoints: 0.95,
  //   maxPoints: 1.15,
  //   formCode: "FFIPPFA1",
  //   factSheet:
  //     "https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Flexible+Income+Plus+Prescient+Fund/OP+-+Fairtree+Flexible+Income+Prescient+Fund.pdf",
  //   onePager:
  //     "https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Flexible+Income+Plus+Prescient+Fund/OP+-+Fairtree+Flexible+Income+Prescient+Fund.pdf",
  //   formSlug: "presient_individual_investor_application",
  //   retirementFormSlug: "presient_ra_investor_application",
  //   taxFreeFormSlug: "presient_tf_investor_application",
  // },
  {
    id: 3,

    name: 'Fairtree SA Money Market Prescient Fund',
    vehicles: ['Basic Investment', 'Retirement Annuity', 'Tax-Free Savings Account'],
    time: '1-2 years',
    risk: 'Conservative',
    assetHoldings: 'Money Market',
    regionalHoldings: 'Local',
    formCode: 'FMMPFA1',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-sa-money-market-prescient-fund-mdd.pdf',
    formSlug: 'presient_individual_investor_application',
    retirementFormSlug: 'presient_ra_investor_application',
    taxFreeFormSlug: 'presient_tf_investor_application',
  },
  {
    id: 4,

    name: 'Fairtree ALBI Plus Prescient Fund',
    vehicles: ['Basic Investment', 'Retirement Annuity', 'Tax-Free Savings Account'],
    time: '1-3 years',
    risk: 'Moderately Conservative',
    assetHoldings: 'Fixed Income / Bonds',
    regionalHoldings: 'Local',
    formCode: 'FAPPFA1',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-albi-plus-prescient-fund-mdd.pdf',
    formSlug: 'presient_individual_investor_application',
    retirementFormSlug: 'presient_ra_investor_application',
    taxFreeFormSlug: 'presient_tf_investor_application',
  },
  {
    id: 5,

    name: 'Fairtree SA Balanced Prescient Fund',
    vehicles: ['Basic Investment', 'Retirement Annuity'],
    time: '5+ years',
    risk: 'Moderately Aggressive',
    assetHoldings: 'Equity, Property, Fixed Income/ Bonds, Commodities',
    regionalHoldings: 'Local and Offshore',
    formCode: 'FASAA1',
    formSlug: 'presient_individual_investor_application',
    retirementFormSlug: 'presient_ra_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-sa-balanced-prescient-fund-mdd.pdf',
    withdrawWarning: true,
  },
  {
    id: 6,

    name: 'Fairtree Equity Prescient Fund',
    vehicles: ['Basic Investment'],
    time: '7+ years',
    risk: 'Aggressive',
    assetHoldings: 'Equity',
    regionalHoldings: 'Local and Offshore',
    formCode: 'FTBIA1',
    formSlug: 'presient_individual_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-equity-prescient-fund-mdd.pdf',
    withdrawWarning: true,
  },
  {
    id: 7,

    name: 'Fairtree SA Equity Prescient Fund',
    vehicles: ['Basic Investment', 'Tax-Free Savings Account'],
    useForTaxFreeInvestmentHelp: {
      enable: true,
      minPoints: 2.4,
      maxPoints: 3.2,
    },
    time: '7+ years',
    risk: 'Aggressive',
    assetHoldings: 'Equity',
    regionalHoldings: 'Local',
    formCode: 'FEPFA1',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-sa-equity-prescient-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Equity+Prescient+Fund/Fairtree+Equity+Prescient+Fund.pdf',
    formSlug: 'presient_individual_investor_application',
    taxFreeFormSlug: 'presient_tf_investor_application',
    withdrawWarning: true,
  },
  {
    id: 8,

    name: 'Fairtree Balanced Prescient Fund',
    vehicles: ['Basic Investment', 'Retirement Annuity', 'Tax-Free Savings Account'],
    useForTaxFreeInvestmentHelp: {
      enable: true,
      minPoints: 1.5,
      maxPoints: 2.3,
    },
    time: '5+ years',
    risk: 'Moderately Aggressive',
    assetHoldings: 'Equity, Property, Fixed Income/ Bonds, Commodities',
    regionalHoldings: 'Local and Offshore',
    formCode: 'FBPFA3',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-balanced-prescient-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Balanced+Prescient+Fund/OP+-+Fairtree+Balanced+Prescient+Fund.pdf',
    formSlug: 'presient_individual_investor_application',
    retirementFormSlug: 'presient_ra_investor_application',
    taxFreeFormSlug: 'presient_tf_investor_application',
    withdrawWarning: true,
  },
  {
    id: 9,

    name: 'Fairtree Select Equity Prescient Fund',
    vehicles: ['Basic Investment', 'Tax-Free Savings Account'],
    time: '7+ years',
    risk: 'Aggressive',
    assetHoldings: 'Equity',
    regionalHoldings: 'Local and Offshore',
    formCode: 'FSEPFA1',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-select-equity-prescient-fund-mdd.pdf',
    formSlug: 'presient_individual_investor_application',
    taxFreeFormSlug: 'presient_tf_investor_application',
    withdrawWarning: true,
  },
  {
    id: 10,

    name: 'Fairtree Global Real Estate Prescient Feeder Fund',
    vehicles: ['Basic Investment', 'Tax-Free Savings Account'],
    time: '7+ years',
    risk: 'Aggressive',
    assetHoldings: 'Property',
    regionalHoldings: 'Offshore',
    formCode: 'FGREPFFA1',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-global-real-estate-prescient-feeder-fund-mdd.pdf',
    formSlug: 'presient_individual_investor_application',
    taxFreeFormSlug: 'presient_tf_investor_application',
    withdrawWarning: true,
  },
  {
    id: 11,

    name: 'Fairtree Global Equity Prescient Feeder Fund',
    vehicles: ['Basic Investment', 'Tax-Free Savings Account'],
    time: '7+ years',
    risk: 'Aggressive',
    assetHoldings: 'Equity',
    regionalHoldings: 'Local and Offshore',
    formCode: 'FGEPFFA3',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-global-equity-prescient-feeder-fund-mdd.pdf',
    formSlug: 'presient_individual_investor_application',
    taxFreeFormSlug: 'presient_tf_investor_application',
    withdrawWarning: true,
  },
  {
    id: 12,

    name: 'Fairtree Global Emerging Markets Prescient Feeder Fund',
    vehicles: ['Basic Investment', 'Tax-Free Savings Account'],
    time: '7+ years',
    risk: 'Aggressive',
    assetHoldings: 'Equity',
    regionalHoldings: 'Local and Offshore',
    formCode: 'FGEMPFA1',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-global-emerging-markets-prescient-feeder-fund-mdd.pdf',
    formSlug: 'presient_individual_investor_application',
    taxFreeFormSlug: 'presient_tf_investor_application',
    withdrawWarning: true,
  },
  {
    id: 13,

    name: 'Fairtree Flexible Balanced Prescient Fund',
    vehicles: ['Basic Investment', 'Retirement Annuity', 'Tax-Free Savings Account'],
    useForTaxFreeInvestmentHelp: {
      enable: true,
      minPoints: 1,
      maxPoints: 1.4,
    },
    time: '5+ years',
    risk: 'Moderate',
    assetHoldings: 'Equity, Property, Fixed Income/ Bonds, Commodities ',
    regionalHoldings: 'Local and Offshore',
    formCode: 'FFBPFA3',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-flexible-balanced-prescient-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Flexible+Balanced+Prescient+Fund/OP+-+Fairtree+Flexible+Balanced+Prescient+Fund.pdf',
    formSlug: 'presient_individual_investor_application',
    retirementFormSlug: 'presient_ra_investor_application',
    taxFreeFormSlug: 'presient_tf_investor_application',
    withdrawWarning: true,
  },
  {
    id: 14,

    name: 'Fairtree Worldwide Multi-Strategy Flexible Prescient Fund',
    vehicles: ['Basic Investment', 'Tax-Free Savings Account'],
    time: '5+ years',
    risk: 'Moderately Aggressive',
    assetHoldings: 'Equity, Property, Fixed Income/ Bonds, Commodities ',
    regionalHoldings: 'Local and Offshore',
    useForBasicInvestmentHelp: true,
    minPoints: 3.31,
    maxPoints: 4.7,
    formCode: 'FWMSFPFA1',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-worldwide-multi-strategy-flexible-prescient-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Worldwide+Multi-Strategy+Flexible+Prescient+Fund/OP+-+Fairtree+Worldwide+Multi-Strategy+Flexible+Prescient+Fund.pdf',
    formSlug: 'presient_individual_investor_application',
    taxFreeFormSlug: 'presient_tf_investor_application',
    withdrawWarning: true,
  },
  {
    id: 15,

    name: 'Fairtree Invest Strategic Factor Prescient Fund',
    vehicles: ['Basic Investment', 'Retirement Annuity', 'Tax-Free Savings Account'],
    time: '7+ years',
    risk: 'Moderately Aggressive',
    assetHoldings: 'Equity, Property, Fixed Income/ Bonds, Commodities ',
    regionalHoldings: 'Local and Offshore',
    formCode: 'FISFPFA1',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-investment-strategy-factor-prescient-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Invest+Strategic+Factor+Prescient+Fund/OP+-+Fairtree+Invest+Strategic+Factor+Prescient+Fund.pdf',
    formSlug: 'presient_individual_investor_application',
    retirementFormSlug: 'presient_ra_investor_application',
    taxFreeFormSlug: 'presient_tf_investor_application',
    withdrawWarning: true,
  },
  {
    id: 16,
    name: '50% Fairtree Flexible Income Plus Prescient Fund & 50% Fairtree Flexible Balanced Prescient Fund',
    vehicles: [],
    time: '1-2 years',
    risk: 'Conservative',
    assetHoldings: 'Fixed Income / Bonds',
    regionalHoldings: 'Local and Offshore',
    useForBasicInvestmentHelp: true,
    minPoints: 1.16,
    maxPoints: 2.1,
    split: [
      { id: 1, percent: 50 },
      { id: 10, percent: 50 },
    ],
    factSheet: [
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Flexible+Income+Plus+Prescient+Fund/OP+-+Fairtree+Flexible+Income+Prescient+Fund.pdf',
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-flexible-balanced-prescient-fund-mdd.pdf',
    ],
    onePager: [
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Flexible+Income+Plus+Prescient+Fund/OP+-+Fairtree+Flexible+Income+Prescient+Fund.pdf',
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Flexible+Balanced+Prescient+Fund/OP+-+Fairtree+Flexible+Balanced+Prescient+Fund.pdf',
    ],
    formSlug: 'presient_individual_investor_application',
  },
  {
    id: 17,
    name: '50% Fairtree Flexible Income Plus Prescient Fund & 50% Fairtree Worldwide Multi-Strategy Flexible Prescient Fund',
    vehicles: [],
    time: '1-2 years',
    risk: 'Conservative',
    assetHoldings: 'Fixed Income / Bonds',
    regionalHoldings: 'Local and Offshore',
    useForBasicInvestmentHelp: true,
    minPoints: 2.11,
    maxPoints: 3.3,
    split: [
      { id: 1, percent: 50 },
      { id: 11, percent: 50 },
    ],
    factSheet: [
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Flexible+Income+Plus+Prescient+Fund/OP+-+Fairtree+Flexible+Income+Prescient+Fund.pdf',
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Worldwide+Multi-Strategy+Flexible+Prescient+Fund/OP+-+Fairtree+Worldwide+Multi-Strategy+Flexible+Prescient+Fund.pdf',
    ],
    onePager: [
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Flexible+Income+Plus+Prescient+Fund/OP+-+Fairtree+Flexible+Income+Prescient+Fund.pdf',
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Worldwide+Multi-Strategy+Flexible+Prescient+Fund/OP+-+Fairtree+Worldwide+Multi-Strategy+Flexible+Prescient+Fund.pdf',
    ],
    formSlug: 'presient_individual_investor_application',
  },
  {
    id: 18,
    name: 'Fairtree Wild Fig Multi-Strategy FR Retail Hedge Fund',
    vehicles: ['Retail Investor Hedge Fund'],
    time: '7+ years',
    class: 2,
    risk: 'Medium-High',
    assetHoldings: 'Commodities, Equity and Fixed Income',
    regionalHoldings: 'Local and Offshore',
    useForBasicInvestmentHelp: false,
    useForRetirementAnnuityHelp: false,
    extendedForm: true,
    formCode: 'FWFMS',
    formSlug: 'apex_rihf_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-wild-fig-multi-strategy-fr-retail-hedge-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Equity+Market+Neutral+SNN+QI+Hedge+Fund/Fairtree+Equity+Market+Neutral+SNN+QI+Hedge+Fund.pdf',
    withdrawWarning: true,
  },
  {
    id: 19,
    name: 'Fairtree Worldwide Multi-Strategy Flexible FR Retail Hedge Fund',
    vehicles: ['Retail Investor Hedge Fund'],
    time: '7+ years',
    class: 6,
    risk: 'Medium-High',
    assetHoldings:
      'Equity, Property, Fixed Income, Directional Equity, Directional Fixed Income/Credit',
    regionalHoldings: 'Local and Offshore',
    useForBasicInvestmentHelp: false,
    minPoints: 3.31,
    maxPoints: 4.7,
    formCode: 'FWWMSQ',
    formSlug: 'apex_rihf_investor_application',
    extendedForm: true,
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-worldwide-multi-strategy-flexible-fr-retail-hedge-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/RHF+The+Fairtree+Worldwide+Multi-Strategy+Hedge+Fund/FAIRTREE+RIHF+(Compliance).pdf',
    withdrawWarning: true,
  },
  {
    id: 20,
    name: 'Fairtree Worldwide Multi-Strategy Flexible FR QI Hedge Fund',
    vehicles: ['Qualified Investor Hedge Fund'],
    time: '7+ years',
    class: 8,
    risk: 'High',
    assetHoldings:
      'Equity, Property, Fixed Income, Directional Equity, Directional Soft Commodities, Directional Fixed Income/Credit',
    regionalHoldings: 'Local and Offshore',
    useForBasicInvestmentHelp: true,
    minPoints: 3.31,
    maxPoints: 4.7,
    minInvestment: 1000000,
    disableDebitOrder: true,
    extendedForm: true,
    formCode: 'FWWMSQF',
    formSlug: 'apex_qihf_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-worldwide-multi-strategy-flexible-fr-qi-hedge-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/QHF+The+Fairtree+Worldwide+Multi-Strategy+Hedge+Fund/FAIRTREE+QIHF+(Compliance).pdf',
    withdrawWarning: true,
  },
  {
    id: 21,
    name: 'Fairtree Stable HV RPF',
    vehicles: [],
    time: '3-4 years',
    risk: 'Moderately Conservative',
    assetHoldings:
      'Equity, Property, Fixed Income, Directional Equity, Directional Commodities, Directional Fixed Income/Credit',
    regionalHoldings: 'Local and Offshore',
    useForBasicInvestmentHelp: false,
    useForRetirementAnnuityHelp: {
      enable: true,
      minPoints: 1,
      maxPoints: 2,
    },
    formCode: 'TFCMMP',
    factSheet:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Cautious+Multi-+Managed+Portfolio/Fairtree+Cautious+MM+(EB).pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Cautious+Multi-+Managed+Portfolio/Fairtree+Cautious+MM+(EB).pdf',
    retirementFormSlug: 'mommentum_ra_investor_application',
  },
  {
    id: 22,
    name: 'Fairtree Proton RCIS Retail Hedge Fund',
    class: 'A',
    vehicles: ['Retail Investor Hedge Fund'],
    time: '1-3 years',
    risk: 'Low-Medium',
    assetHoldings: 'Directional Fixed Income / Bonds',
    regionalHoldings: 'Local',
    useForBasicInvestmentHelp: false,
    useForRetirementAnnuityHelp: false,
    disableDebitOrder: true,
    deitOrderNote:
      'Our administrator is in the process of setting up Debit Order capabilities of R2,000 per month. If you would like one of our consultants to contact you about this please send us an email on ',
    extendedForm: true,
    formCode: '',
    formSlug: 'proton_hf_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-proton-rcis-retail-hedge-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Proton+RCIS+Retail+Investor+Hedge+Fund/Fairtree+Proton+RCIS+Retail+Hedge+Fund.pdf',
    withdrawWarning: true,
  },
  {
    id: 23,
    name: 'Fairtree Fixed Income FR Retail Hedge Fund',
    vehicles: ['Retail Investor Hedge Fund'],
    time: '1-3 years',
    class: 1,
    risk: 'Medium-High',
    assetHoldings: 'Directional Fixed Income / Bonds',
    regionalHoldings: 'Local and Offshore',
    useForBasicInvestmentHelp: false,
    useForRetirementAnnuityHelp: false,
    extendedForm: true,
    formCode: 'FFISNR',
    formSlug: 'apex_rihf_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-fixed-income-fr-retail-hedge-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Fixed+Income+SNN+Retail+Investor+Hedge+Fund/Fairtree+Fixed+Income+SNN+Retail+Hedge+Fund.pdf',
  },
  // {
  //   id: 20,
  //   name: "Fairtree Marula Equity Long Short SNN Retail Investor Hedge Fund",
  //   vehicles: ["Retail Investor Hedge Fund"],
  //   time: "1-3 years",
  //   risk: "Medium-High",
  //   assetHoldings: "Directional Equity",
  //   regionalHoldings: "Local and Offshore",
  //   useForBasicInvestmentHelp: false,
  //   useForRetirementAnnuityHelp: false,
  //   extendedForm: true,
  //   formCode: "FTRHF1",
  //   formSlug: "apex_rihf_investor_application",
  //   factSheet:
  //     "https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Marula+Equity+Long+Short+SNN+Retail+Investor+Hedge+Fund/Fairtree+Marula+Equity+Long+Short+SNN+Retail+Hedge+Fund.pdf",
  //   onePager:
  //     "https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Marula+Equity+Long+Short+SNN+Retail+Investor+Hedge+Fund/Fairtree+Marula+Equity+Long+Short+SNN+Retail+Hedge+Fund.pdf",
  //   withdrawWarning: true,
  // },
  {
    id: 24,
    name: 'Fairtree Assegai Equity Long Short FR Qi Hedge Fund',
    vehicles: ['Qualified Investor Hedge Fund'],
    class: 1,
    time: '7+ years',
    risk: 'High',
    assetHoldings: 'Directional Equity',
    regionalHoldings: 'Local',
    useForBasicInvestmentHelp: false,
    useForRetirementAnnuityHelp: false,
    disableDebitOrder: true,
    extendedForm: true,
    formCode: 'FTASEQ',
    formSlug: 'apex_qihf_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-assegai-equity-long-short-fr-qi-hedge-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Assegai+Equity+Long+Short+SNN+Qi+Hedge+Fund/Fairtree+Assegai+Equity+Long+Short+SNN+QI+Hedge+Fund.pdf',
    withdrawWarning: true,
  },
  {
    id: 25,
    name: 'Fairtree Wild Fig Multi Strategy FR Qi Hedge Fund',
    vehicles: ['Qualified Investor Hedge Fund'],
    time: '5+ years',
    class: 1,
    risk: 'Medium-High',
    assetHoldings: 'Directional: Commodities, Fixed Income, Equity',
    regionalHoldings: 'Local and Offshore',
    useForBasicInvestmentHelp: false,
    useForRetirementAnnuityHelp: false,
    disableDebitOrder: true,
    extendedForm: true,
    formCode: 'FTWFIG',
    formSlug: 'apex_qihf_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-wild-fig-multi-strategy-fr-qi-hedge-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Wild+Fig+Multi+Strategy+SNN+Qi+Hedge+Fund/Fairtree+Wild+Fig+Multi+Strategy+SNN+QI+Hedge+Fund.pdf',
    withdrawWarning: true,
  },
  // {
  //   id: 26,
  //   name: 'Fairtree Woodland Multi Strategy FR Qi Hedge Fund',
  //   vehicles: ['Qualified Investor Hedge Fund'],
  //   time: '5+ years',
  //   risk: 'Medium-High',
  //   assetHoldings: 'Directional: Commodities, Fixed Income, Equity',
  //   regionalHoldings: 'Local and Offshore',
  //   useForBasicInvestmentHelp: false,
  //   useForRetirementAnnuityHelp: false,
  //   disableDebitOrder: true,
  //   extendedForm: true,
  //   formCode: 'FWOOD1',
  //   formSlug: 'apex_qihf_investor_application',
  //   factSheet:
  //     'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Woodland+Multi+Strategy+SNN+Qi+Hedge+Fund/Fairtree+Woodland+Multi+Strategy+SNN+QI+Hedge+Fund.pdf',
  //   onePager:
  //     'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Woodland+Multi+Strategy+SNN+Qi+Hedge+Fund/Fairtree+Woodland+Multi+Strategy+SNN+QI+Hedge+Fund.pdf',
  //   withdrawWarning: true,
  // },
  {
    id: 26,
    name: 'Fairtree Wild Fig Defensive Multi- Strategy FR Retail Hedge Fund',
    time: '5+ years',
    class: 1,
    vehicles: ['Retail Investor Hedge Fund'],
    risk: 'Medium',
    assetHoldings:
      'Equities, Fixed Income, Commodities, Property, REITs, ETFs, Currencies, Money Market Instruments',
    regionalHoldings: 'Local',
    formCode: 'FWFHF',
    formSlug: 'apex_rihf_investor_application',
    extendedForm: true,
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-wild-fig-defensive-multi-strategy-fr-retail-hedge-fund-mdd.pdf',
    withdrawWarning: true,
  },
  {
    id: 27,
    name: 'Fairtree Moderate HV RPF',
    vehicles: [],
    time: '4-5 years',
    risk: 'Moderate',
    assetHoldings:
      'Equity, Property, Fixed Income, Directional Equity, Directional Commodities, Directional Fixed Income/Credit',
    regionalHoldings: 'Local and Offshore',
    useForBasicInvestmentHelp: false,
    useForRetirementAnnuityHelp: {
      enable: true,
      minPoints: 2.1,
      maxPoints: 3.1,
    },
    formCode: 'TFBMMP',
    factSheet:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Balanced+Multi-+Managed+Portfolio/Fairtree+Balanced+MM+(EB).pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Balanced+Multi-+Managed+Portfolio/Fairtree+Balanced+MM+(EB).pdf',
    retirementFormSlug: 'mommentum_ra_investor_application',
  },
  {
    id: 28,
    name: 'Fairtree Balanced HV RPF',
    vehicles: [],
    time: '7+ years',
    risk: 'Moderately Aggressive',
    assetHoldings:
      'Equity, Property, Fixed Income, Directional Equity, Directional Commodities, Directional Fixed Income/Credit',
    regionalHoldings: 'Local and Offshore',
    useForBasicInvestmentHelp: false,
    useForRetirementAnnuityHelp: {
      enable: true,
      minPoints: 3.2,
      maxPoints: 5,
    },
    formCode: 'TFGMMP',
    factSheet:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Growth+Multi-Managed+Portfolio/Fairtree+Growth+MM+(EB).pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Growth+Multi-Managed+Portfolio/Fairtree+Growth+MM+(EB).pdf',
    retirementFormSlug: 'mommentum_ra_investor_application',
  },
  {
    id: 29,
    name: 'Fairtree Silver Oak Equity Long Short FR Retail Hedge Fund',
    vehicles: ['Retail Investor Hedge Fund'],
    time: '7+ years',
    class: 1,
    risk: 'High',
    assetHoldings: 'Directional Equity',
    regionalHoldings: 'Local',
    useForBasicInvestmentHelp: false,
    useForRetirementAnnuityHelp: false,
    extendedForm: true,
    formCode: 'FAICL1',
    formSlug: 'apex_rihf_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-silver-oak-equity-long-short-fr-retail-hedge-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Silver+Oak+Equity+Long+Short+SNN+Retail+Hedge+Fund/Fairtree+Silver+Oak+Equity+Long+Short+SNN+Retail+Hedge+Fund.pdf',
    withdrawWarning: true,
  },
  {
    id: 30,
    name: 'Fairtree Equity Market Neutral FR QI Hedge Fund',
    vehicles: ['Qualified Investor Hedge Fund'],
    time: '3+ years',
    class: 1,
    risk: 'Medium',
    assetHoldings: 'Relative Equity',
    regionalHoldings: 'Local',
    useForBasicInvestmentHelp: false,
    useForRetirementAnnuityHelp: false,
    disableDebitOrder: true,
    extendedForm: true,
    formCode: 'FTEQMN',
    formSlug: 'apex_qihf_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-equity-market-neutral-fr-qi-hedge-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+Equity+Market+Neutral+SNN+QI+Hedge+Fund/Fairtree+Equity+Market+Neutral+SNN+QI+Hedge+Fund.pdf',
    withdrawWarning: true,
  },

  {
    id: 31,
    name: 'Fairtree FR Income Plus Fund',
    vehicles: ['Basic Investment'],
    time: '3+ years',
    risk: 'Moderately Conservative',
    assetHoldings: 'Bonds, Cash, Equity',
    regionalHoldings: 'Local and Offshore',
    formCode: 'BIPFA',
    formSlug: 'bci_individual_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-fr-income-plus-fund-mdd.pdf',
    onePager:
      'https://s3.af-south-1.amazonaws.com/s3.fairtree.public/funds/Fairtree+BCI+Income+Plus+Fund+(One+Pager)/Fairtree+BCI+Income+Plus+Fund+(One+Pager).pdf',
  },
  {
    id: 32,
    name: 'Fairtree FR Select Cautious Fund',
    vehicles: ['Basic Investment'],
    time: '3+ years',
    risk: 'Moderately Conservative',
    assetHoldings: 'Bonds, Cash, Equity',
    regionalHoldings: 'Local and Offshore',
    formCode: 'EBCC',
    formSlug: 'bci_individual_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-fr-select-cautious-fund-mdd.pdf',
    onePager: '',
  },
  {
    id: 33,
    name: 'FR Fairtree Global Income Plus Feeder Fund',
    vehicles: ['Basic Investment'],
    time: '3+ years',
    risk: 'Moderately Conservative',
    assetHoldings: 'Bonds, Cash, Equity',
    regionalHoldings: 'Local and Offshore',
    formCode: 'BCFFDA',
    formSlug: 'bci_individual_investor_application',
    factSheet:
      'https://www.fairtree.com/wp-content/uploads/mdd/fairtree-fr-global-income-plus-feeder-fund-mdd.pdf',
    onePager: '',
  },
];

export const CountryList = [
  {
    code: 'AFG',
    label: 'Afghanistan',
  },
  {
    code: 'ALA',
    label: 'Åland Islands',
  },
  {
    code: 'ALB',
    label: 'Albania',
  },
  {
    code: 'DZA',
    label: 'Algeria',
  },
  {
    code: 'ASM',
    label: 'American Samoa',
  },
  {
    code: 'AND',
    label: 'Andorra',
  },
  {
    code: 'AGO',
    label: 'Angola',
  },
  {
    code: 'AIA',
    label: 'Anguilla',
  },
  {
    code: 'ATA',
    label: 'Antarctica',
  },
  {
    code: 'ATG',
    label: 'Antigua and Barbuda',
  },
  {
    code: 'ARG',
    label: 'Argentina',
  },
  {
    code: 'ARM',
    label: 'Armenia',
  },
  {
    code: 'ABW',
    label: 'Aruba',
  },
  {
    code: 'AUS',
    label: 'Australia',
  },
  {
    code: 'AUT',
    label: 'Austria',
  },
  {
    code: 'AZE',
    label: 'Azerbaijan',
  },
  {
    code: 'BHS',
    label: 'Bahamas',
  },
  {
    code: 'BHR',
    label: 'Bahrain',
  },
  {
    code: 'BGD',
    label: 'Bangladesh',
  },
  {
    code: 'BRB',
    label: 'Barbados',
  },
  {
    code: 'BLR',
    label: 'Belarus',
  },
  {
    code: 'BEL',
    label: 'Belgium',
  },
  {
    code: 'BLZ',
    label: 'Belize',
  },
  {
    code: 'BEN',
    label: 'Benin',
  },
  {
    code: 'BMU',
    label: 'Bermuda',
  },
  {
    code: 'BTN',
    label: 'Bhutan',
  },
  {
    code: 'BOL',
    label: 'Bolivia, Plurinational State of',
  },
  {
    code: 'BES',
    label: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    code: 'BIH',
    label: 'Bosnia and Herzegovina',
  },
  {
    code: 'BWA',
    label: 'Botswana',
  },
  {
    code: 'BVT',
    label: 'Bouvet Island',
  },
  {
    code: 'BRA',
    label: 'Brazil',
  },
  {
    code: 'IOT',
    label: 'British Indian Ocean Territory',
  },
  {
    code: 'BRN',
    label: 'Brunei Darussalam',
  },
  {
    code: 'BGR',
    label: 'Bulgaria',
  },
  {
    code: 'BFA',
    label: 'Burkina Faso',
  },
  {
    code: 'BDI',
    label: 'Burundi',
  },
  {
    code: 'KHM',
    label: 'Cambodia',
  },
  {
    code: 'CMR',
    label: 'Cameroon',
  },
  {
    code: 'CAN',
    label: 'Canada',
  },
  {
    code: 'CPV',
    label: 'Cape Verde',
  },
  {
    code: 'CYM',
    label: 'Cayman Islands',
  },
  {
    code: 'CAF',
    label: 'Central African Republic',
  },
  {
    code: 'TCD',
    label: 'Chad',
  },
  {
    code: 'CHL',
    label: 'Chile',
  },
  {
    code: 'CHN',
    label: 'China',
  },
  {
    code: 'CXR',
    label: 'Christmas Island',
  },
  {
    code: 'CCK',
    label: 'Cocos (Keeling) Islands',
  },
  {
    code: 'COL',
    label: 'Colombia',
  },
  {
    code: 'COM',
    label: 'Comoros',
  },
  {
    code: 'COG',
    label: 'Congo',
  },
  {
    code: 'COD',
    label: 'Congo, the Democratic Republic of the',
  },
  {
    code: 'COK',
    label: 'Cook Islands',
  },
  {
    code: 'CRI',
    label: 'Costa Rica',
  },
  {
    code: 'CIV',
    label: "Côte d'Ivoire",
  },
  {
    code: 'HRV',
    label: 'Croatia',
  },
  {
    code: 'CUB',
    label: 'Cuba',
  },
  {
    code: 'CUW',
    label: 'Curaçao',
  },
  {
    code: 'CYP',
    label: 'Cyprus',
  },
  {
    code: 'CZE',
    label: 'Czech Republic',
  },
  {
    code: 'DNK',
    label: 'Denmark',
  },
  {
    code: 'DJI',
    label: 'Djibouti',
  },
  {
    code: 'DMA',
    label: 'Dominica',
  },
  {
    code: 'DOM',
    label: 'Dominican Republic',
  },
  {
    code: 'ECU',
    label: 'Ecuador',
  },
  {
    code: 'EGY',
    label: 'Egypt',
  },
  {
    code: 'SLV',
    label: 'El Salvador',
  },
  {
    code: 'GNQ',
    label: 'Equatorial Guinea',
  },
  {
    code: 'ERI',
    label: 'Eritrea',
  },
  {
    code: 'EST',
    label: 'Estonia',
  },
  {
    code: 'ETH',
    label: 'Ethiopia',
  },
  {
    code: 'FLK',
    label: 'Falkland Islands (Malvinas)',
  },
  {
    code: 'FRO',
    label: 'Faroe Islands',
  },
  {
    code: 'FJI',
    label: 'Fiji',
  },
  {
    code: 'FIN',
    label: 'Finland',
  },
  {
    code: 'FRA',
    label: 'France',
  },
  {
    code: 'GUF',
    label: 'French Guiana',
  },
  {
    code: 'PYF',
    label: 'French Polynesia',
  },
  {
    code: 'ATF',
    label: 'French Southern Territories',
  },
  {
    code: 'GAB',
    label: 'Gabon',
  },
  {
    code: 'GMB',
    label: 'Gambia',
  },
  {
    code: 'GEO',
    label: 'Georgia',
  },
  {
    code: 'DEU',
    label: 'Germany',
  },
  {
    code: 'GHA',
    label: 'Ghana',
  },
  {
    code: 'GIB',
    label: 'Gibraltar',
  },
  {
    code: 'GRC',
    label: 'Greece',
  },
  {
    code: 'GRL',
    label: 'Greenland',
  },
  {
    code: 'GRD',
    label: 'Grenada',
  },
  {
    code: 'GLP',
    label: 'Guadeloupe',
  },
  {
    code: 'GUM',
    label: 'Guam',
  },
  {
    code: 'GTM',
    label: 'Guatemala',
  },
  {
    code: 'GGY',
    label: 'Guernsey',
  },
  {
    code: 'GIN',
    label: 'Guinea',
  },
  {
    code: 'GNB',
    label: 'Guinea-Bissau',
  },
  {
    code: 'GUY',
    label: 'Guyana',
  },
  {
    code: 'HTI',
    label: 'Haiti',
  },
  {
    code: 'HMD',
    label: 'Heard Island and McDonald Islands',
  },
  {
    code: 'VAT',
    label: 'Holy See (Vatican City State)',
  },
  {
    code: 'HND',
    label: 'Honduras',
  },
  {
    code: 'HKG',
    label: 'Hong Kong',
  },
  {
    code: 'HUN',
    label: 'Hungary',
  },
  {
    code: 'ISL',
    label: 'Iceland',
  },
  {
    code: 'IND',
    label: 'India',
  },
  {
    code: 'IDN',
    label: 'Indonesia',
  },
  {
    code: 'IRN',
    label: 'Iran, Islamic Republic of',
  },
  {
    code: 'IRQ',
    label: 'Iraq',
  },
  {
    code: 'IRL',
    label: 'Ireland',
  },
  {
    code: 'IMN',
    label: 'Isle of Man',
  },
  {
    code: 'ISR',
    label: 'Israel',
  },
  {
    code: 'ITA',
    label: 'Italy',
  },
  {
    code: 'JAM',
    label: 'Jamaica',
  },
  {
    code: 'JPN',
    label: 'Japan',
  },
  {
    code: 'JEY',
    label: 'Jersey',
  },
  {
    code: 'JOR',
    label: 'Jordan',
  },
  {
    code: 'KAZ',
    label: 'Kazakhstan',
  },
  {
    code: 'KEN',
    label: 'Kenya',
  },
  {
    code: 'KIR',
    label: 'Kiribati',
  },
  {
    code: 'PRK',
    label: "Korea, Democratic People's Republic of",
  },
  {
    code: 'KOR',
    label: 'Korea, Republic of',
  },
  {
    code: 'KWT',
    label: 'Kuwait',
  },
  {
    code: 'KGZ',
    label: 'Kyrgyzstan',
  },
  {
    code: 'LAO',
    label: "Lao People's Democratic Republic",
  },
  {
    code: 'LVA',
    label: 'Latvia',
  },
  {
    code: 'LBN',
    label: 'Lebanon',
  },
  {
    code: 'LSO',
    label: 'Lesotho',
  },
  {
    code: 'LBR',
    label: 'Liberia',
  },
  {
    code: 'LBY',
    label: 'Libya',
  },
  {
    code: 'LIE',
    label: 'Liechtenstein',
  },
  {
    code: 'LTU',
    label: 'Lithuania',
  },
  {
    code: 'LUX',
    label: 'Luxembourg',
  },
  {
    code: 'MAC',
    label: 'Macao',
  },
  {
    code: 'MKD',
    label: 'Macedonia, the former Yugoslav Republic of',
  },
  {
    code: 'MDG',
    label: 'Madagascar',
  },
  {
    code: 'MWI',
    label: 'Malawi',
  },
  {
    code: 'MYS',
    label: 'Malaysia',
  },
  {
    code: 'MDV',
    label: 'Maldives',
  },
  {
    code: 'MLI',
    label: 'Mali',
  },
  {
    code: 'MLT',
    label: 'Malta',
  },
  {
    code: 'MHL',
    label: 'Marshall Islands',
  },
  {
    code: 'MTQ',
    label: 'Martinique',
  },
  {
    code: 'MRT',
    label: 'Mauritania',
  },
  {
    code: 'MUS',
    label: 'Mauritius',
  },
  {
    code: 'MYT',
    label: 'Mayotte',
  },
  {
    code: 'MEX',
    label: 'Mexico',
  },
  {
    code: 'FSM',
    label: 'Micronesia, Federated States of',
  },
  {
    code: 'MDA',
    label: 'Moldova, Republic of',
  },
  {
    code: 'MCO',
    label: 'Monaco',
  },
  {
    code: 'MNG',
    label: 'Mongolia',
  },
  {
    code: 'MNE',
    label: 'Montenegro',
  },
  {
    code: 'MSR',
    label: 'Montserrat',
  },
  {
    code: 'MAR',
    label: 'Morocco',
  },
  {
    code: 'MOZ',
    label: 'Mozambique',
  },
  {
    code: 'MMR',
    label: 'Myanmar',
  },
  {
    code: 'NAM',
    label: 'Namibia',
  },
  {
    code: 'NRU',
    label: 'Nauru',
  },
  {
    code: 'NPL',
    label: 'Nepal',
  },
  {
    code: 'NLD',
    label: 'Netherlands',
  },
  {
    code: 'NCL',
    label: 'New Caledonia',
  },
  {
    code: 'NZL',
    label: 'New Zealand',
  },
  {
    code: 'NIC',
    label: 'Nicaragua',
  },
  {
    code: 'NER',
    label: 'Niger',
  },
  {
    code: 'NGA',
    label: 'Nigeria',
  },
  {
    code: 'NIU',
    label: 'Niue',
  },
  {
    code: 'NFK',
    label: 'Norfolk Island',
  },
  {
    code: 'MNP',
    label: 'Northern Mariana Islands',
  },
  {
    code: 'NOR',
    label: 'Norway',
  },
  {
    code: 'OMN',
    label: 'Oman',
  },
  {
    code: 'PAK',
    label: 'Pakistan',
  },
  {
    code: 'PLW',
    label: 'Palau',
  },
  {
    code: 'PSE',
    label: 'Palestinian Territory, Occupied',
  },
  {
    code: 'PAN',
    label: 'Panama',
  },
  {
    code: 'PNG',
    label: 'Papua New Guinea',
  },
  {
    code: 'PRY',
    label: 'Paraguay',
  },
  {
    code: 'PER',
    label: 'Peru',
  },
  {
    code: 'PHL',
    label: 'Philippines',
  },
  {
    code: 'PCN',
    label: 'Pitcairn',
  },
  {
    code: 'POL',
    label: 'Poland',
  },
  {
    code: 'PRT',
    label: 'Portugal',
  },
  {
    code: 'PRI',
    label: 'Puerto Rico',
  },
  {
    code: 'QAT',
    label: 'Qatar',
  },
  {
    code: 'REU',
    label: 'Réunion',
  },
  {
    code: 'ROU',
    label: 'Romania',
  },
  {
    code: 'RUS',
    label: 'Russian Federation',
  },
  {
    code: 'RWA',
    label: 'Rwanda',
  },
  {
    code: 'BLM',
    label: 'Saint Barthélemy',
  },
  {
    code: 'SHN',
    label: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    code: 'KNA',
    label: 'Saint Kitts and Nevis',
  },
  {
    code: 'LCA',
    label: 'Saint Lucia',
  },
  {
    code: 'MAF',
    label: 'Saint Martin (French part)',
  },
  {
    code: 'SPM',
    label: 'Saint Pierre and Miquelon',
  },
  {
    code: 'VCT',
    label: 'Saint Vincent and the Grenadines',
  },
  {
    code: 'WSM',
    label: 'Samoa',
  },
  {
    code: 'SMR',
    label: 'San Marino',
  },
  {
    code: 'STP',
    label: 'Sao Tome and Principe',
  },
  {
    code: 'SAU',
    label: 'Saudi Arabia',
  },
  {
    code: 'SEN',
    label: 'Senegal',
  },
  {
    code: 'SRB',
    label: 'Serbia',
  },
  {
    code: 'SYC',
    label: 'Seychelles',
  },
  {
    code: 'SLE',
    label: 'Sierra Leone',
  },
  {
    code: 'SGP',
    label: 'Singapore',
  },
  {
    code: 'SXM',
    label: 'Sint Maarten (Dutch part)',
  },
  {
    code: 'SVK',
    label: 'Slovakia',
  },
  {
    code: 'SVN',
    label: 'Slovenia',
  },
  {
    code: 'SLB',
    label: 'Solomon Islands',
  },
  {
    code: 'SOM',
    label: 'Somalia',
  },
  {
    code: 'ZAF',
    label: 'South Africa',
  },
  {
    code: 'SGS',
    label: 'South Georgia and the South Sandwich Islands',
  },
  {
    code: 'SSD',
    label: 'South Sudan',
  },
  {
    code: 'ESP',
    label: 'Spain',
  },
  {
    code: 'LKA',
    label: 'Sri Lanka',
  },
  {
    code: 'SDN',
    label: 'Sudan',
  },
  {
    code: 'SUR',
    label: 'Surilabel',
  },
  {
    code: 'SJM',
    label: 'Svalbard and Jan Mayen',
  },
  {
    code: 'SWZ',
    label: 'Swaziland',
  },
  {
    code: 'SWE',
    label: 'Sweden',
  },
  {
    code: 'CHE',
    label: 'Switzerland',
  },
  {
    code: 'SYR',
    label: 'Syrian Arab Republic',
  },
  {
    code: 'TWN',
    label: 'Taiwan, Province of China',
  },
  {
    code: 'TJK',
    label: 'Tajikistan',
  },
  {
    code: 'TZA',
    label: 'Tanzania, United Republic of',
  },
  {
    code: 'THA',
    label: 'Thailand',
  },
  {
    code: 'TLS',
    label: 'Timor-Leste',
  },
  {
    code: 'TGO',
    label: 'Togo',
  },
  {
    code: 'TKL',
    label: 'Tokelau',
  },
  {
    code: 'TON',
    label: 'Tonga',
  },
  {
    code: 'TTO',
    label: 'Trinidad and Tobago',
  },
  {
    code: 'TUN',
    label: 'Tunisia',
  },
  {
    code: 'TUR',
    label: 'Turkey',
  },
  {
    code: 'TKM',
    label: 'Turkmenistan',
  },
  {
    code: 'TCA',
    label: 'Turks and Caicos Islands',
  },
  {
    code: 'TUV',
    label: 'Tuvalu',
  },
  {
    code: 'UGA',
    label: 'Uganda',
  },
  {
    code: 'UKR',
    label: 'Ukraine',
  },
  {
    code: 'ARE',
    label: 'United Arab Emirates',
  },
  {
    code: 'GBR',
    label: 'United Kingdom',
  },
  {
    code: 'USA',
    label: 'United States',
  },
  {
    code: 'UMI',
    label: 'United States Minor Outlying Islands',
  },
  {
    code: 'URY',
    label: 'Uruguay',
  },
  {
    code: 'UZB',
    label: 'Uzbekistan',
  },
  {
    code: 'VUT',
    label: 'Vanuatu',
  },
  {
    code: 'VEN',
    label: 'Venezuela, Bolivarian Republic of',
  },
  {
    code: 'VNM',
    label: 'Viet Nam',
  },
  {
    code: 'VGB',
    label: 'Virgin Islands, British',
  },
  {
    code: 'VIR',
    label: 'Virgin Islands, U.S.',
  },
  {
    code: 'WLF',
    label: 'Wallis and Futuna',
  },
  {
    code: 'ESH',
    label: 'Western Sahara',
  },
  {
    code: 'YEM',
    label: 'Yemen',
  },
  {
    code: 'ZMB',
    label: 'Zambia',
  },
  {
    code: 'ZWE',
    label: 'Zimbabwe',
  },
];

export const EmploymentStatusList = [
  { key: 'fulltimeEmployed', value: 'Full-time Employed' },
  { key: 'selfEmployed', value: 'Self-Employed' },
  { key: 'unemployed', value: 'Unemployed' },
  { key: 'minor', value: 'Minor' },
  { key: 'retired', value: 'Retired/Pensioner' },
];

export const IndustriesList = [
  { key: 'indAgriForestFish', value: 'Agriculture, Forestry & Fishing' },
  { key: 'indAerospaceDefense', value: 'Aerospace & Defense' },
  { key: 'indArmedForces', value: 'Armed Forces' },
  { key: 'indArtEntertnmntRecr', value: 'Art/Entertainment & Recreation' },
  { key: 'indBanksFinancialServices', value: 'Banks/Financial Services' },
  { key: 'indCasinos', value: 'Casinos' },
  { key: 'indSales', value: 'Clerical, Services & Sales' },
  { key: 'indCommTechology', value: 'Communication & Technology' },
  { key: 'indConstrInfrastr', value: 'Construction & Infrastucture' },
  { key: 'indConstructionEngineering', value: 'Construction & Engineering' },
  { key: 'indDigitalAssetsCryptoFund', value: 'Digital Assets/Crypto Fund' },
  { key: 'indDiversifiedMetalsMining', value: 'Diversified Metals & Mining' },
  { key: 'indEducation', value: 'Education' },
  { key: 'indExecitive', value: 'Executive' },
  { key: 'indFinServ', value: 'Financial Services' },
  { key: 'indGovEmployee', value: 'Government Employee' },
  { key: 'indGovrmntSOE', value: 'Government/SOE' },
  { key: 'indHealthcareServices', value: 'Healthcare Services' },
  { key: 'indInternetGamblingOnlineBetting', value: 'Internet Gambling/Online Betting Entity' },
  { key: 'indIT', value: 'IT Technician or Artisan' },
  { key: 'indManager', value: 'Manager' },
  { key: 'indManufacturing', value: 'Manufacturing' },
  { key: 'indMedicalHealtcare', value: 'Medical/Healthcare' },
  { key: 'indMining', value: 'Mining' },
  { key: 'indMotorTrade', value: 'Motor Trade' },
  { key: 'indNonProfOrgNGO', value: 'Non-Profit Organisation/NGO' },
  { key: 'indPreciousMetalsMinerals', value: 'Precious Metals & Minerals' },
  { key: 'indProfServices', value: 'Professional Services' },
  { key: 'indRealEstate', value: 'Real Estate' },
  { key: 'indRealEstateServices', value: 'Real Estate Services' },
  { key: 'indRetired', value: 'Pension/Retired' },
  { key: 'indRetail', value: 'Retail' },
  { key: 'indSelfEmployed', value: 'Self-Employed' },
  { key: 'indStateOwnedEntityGovernment', value: 'State Owned Entity/Government' },
  { key: 'indTourism', value: 'Tourism' },
  { key: 'indTransprtStorageLogist', value: 'Transportation, Storage & Logistics' },
  { key: 'indUnemployed', value: 'Unemployed' },
  { key: 'indUtilities', value: 'Utilities' },
];

export const MaritalStatusList = [
  { key: 'msSingle', value: 'Single' },
  { key: 'msANC', value: 'Ante Nuptial Contract' },
  { key: 'msICOP', value: 'In Community of Property' },
  {
    key: 'msOCOPaccrual',
    value: 'Married Out of Commmunity of Property with accrual',
  },
  {
    key: 'msOCOPnoAccrual',
    value: 'Married Out of Commmunity of Property without accrual',
  },
  // { key: "msDivorced", value: "Divorced" },
];

export const PreferedCommunicationList = [
  { key: 'aoboPreferEmail', value: 'Email' },
  { key: 'aoboPreferPost', value: 'Post' },
];

export const SourceOfFundsList = [
  {
    key: 'sofBusiness',
    value: 'Business Activities / Income',
  },
  { key: 'sofChildSupport', value: 'Child/Spouse support payments' },
  {
    key: 'sofDivorceSettlement',
    value: 'Divorce Settlement',
  },
  { key: 'sofDonations', value: 'Donations' },
  { key: 'sofGifts', value: 'Gifts' },
  { key: 'sofInheritance', value: 'Inheritance' },
  { key: 'sofInvestments', value: 'Investment Proceeds' },
  { key: 'sofLoan', value: 'Loan' },
  { key: 'sofPassive', value: 'Passive Income (Rental, Dividends, Interest)' },
  {
    key: 'sofPolicyBenefit',
    value: 'Policy Benefit (Matured/As a Claim/Replacement)',
  },
  { key: 'sofRetirementFunds', value: 'Retirement Funds' },
  { key: 'sofRetirementPayout', value: 'Retirement/Insurance Payout' },
  {
    key: 'sofRoyalties',
    value: 'Royalties',
  },
  { key: 'sofSalary', value: 'Salary / Bonus' },
  { key: 'sofSalesOfAssets', value: 'Sale of Assets' },
  { key: 'sofSaleOfBusiness', value: 'Sale of Business' },
  { key: 'sofSaleOfProperty', value: 'Sale of Property' },
  { key: 'sofSavings', value: 'Savings' },
  { key: 'sofTax', value: 'Tax Refund' },
  { key: 'sofTrade', value: 'Trade/Business' },
  {
    key: 'sofSection14Transfer',
    value: 'Transfer from another retirement fund (Section 14)',
    rules: { vehicle: 'Retirement Annuity' },
  },
  { key: 'sofTrust', value: 'Trust' },
  { key: 'sofWinnings', value: 'Winnings' },
];

export const SourceOfWealthList = [
  { key: 'sowInheritance', value: 'Inheritance' },
  { key: 'sowSavings', value: 'Savings' },
  { key: 'sowSaleOfAssets', value: 'Sale of assets' },
  { key: 'sowSalary', value: 'Salary/Bonus' },
  { key: 'sowPension', value: 'Pension' },
  { key: 'sowAnnuity', value: 'Annuity' },
];

export const NatureOfPersonEntityList = [
  { key: 'boIndividual', value: 'Individual' },
  { key: 'boTrust', value: 'Trust' },
  { key: 'boListedCompany', value: 'Listed company' },
  { key: 'boGovEntity', value: 'Government Entities' },
  { key: 'boRA', value: 'Retirement Funds' },
  { key: 'boSARes', value: 'South African Resident' },
  { key: 'boNonRes', value: 'Non Resident' },
];

export const ExemptReasonList = [
  {
    value: 'Par (a) – a company which is resident in South Africa',
    key: 'exemptReasonParA',
  },
  {
    value:
      'Par (b) – the government, provincial government or municipality (of the Republic of South Africa)',
    key: 'exemptReasonParB',
  },
  {
    value:
      'Par (c) – a public benefit organisation (approved by SARS ito section 30(3) of the Act)',
    key: 'exemptReasonParC',
  },
  {
    value: 'Par (d) – a trust contemplated in section 37A',
    key: 'exemptReasonParD',
  },
  {
    value: 'Par (e) – an institution, body, or board contemplated in section 10(1)(cA) of the Act',
    key: 'exemptReasonParE',
  },
  {
    value:
      'Par (f) – a fund contemplated in section 10(1)(d)(i) or (ii) of the Act (pension fund, pension preservation fund, etc)',
    key: 'exemptReasonParF',
  },
  {
    value: 'Par (g) – a person contemplated in section 10(1)(t) of the Act (CSIR, SANRAL, etc)',
    key: 'exemptReasonParG',
  },
  {
    value:
      'Par (h) – a shareholder in a registered micro business as defined in the Sixth Schedule to the Act to the extent that the aggregate -amount of the dividends paid by that registered micro business to its shareholders during the year of assessment in which that dividend is paid does not exceed R200,000.00 (Two Hundred Thousand Rand)',
    key: 'exemptReasonParH',
  },
  {
    value:
      'Par (i) – a person that is not a resident and the dividend is a dividend contemplated in paragraph (b) of the definition of “dividend” in section 64D (i.e. dividend on a foreign company’s shares listed in SA, such as dual-listed shares)',
    key: 'exemptReasonParI',
  },
  {
    value: 'Par (j) – a portfolio of a collective investment scheme in securities vv',
    key: 'exemptReasonParJ',
  },
  {
    value: 'Par (k) – any person to the extent that the dividend constitutes income of that person',
    key: 'exemptReasonParK',
  },
  {
    value:
      'Par (l) – any person to the extent that the dividend was subject to secondary tax on companies',
    key: 'exemptReasonParL',
  },
  {
    value: 'Par (m) – any fidelity or indemnity fund contemplated in section 10(i)(d)(iii)',
    key: 'exemptReasonParM',
  },
  {
    value:
      'Par (n) – dividends paid by the REIT (Real Estate Investment Trust) or a controlled property company (as defined in section 25 BB) received or accrued before 1 January 2014 (insofar as it does not consist of a dividend in specie)',
    key: 'exemptReasonParN',
  },
  {
    value: 'Par (o) – a small business funding entity as contemplated in section 10(i)(cQ)',
    key: 'exemptReasonParO',
  },
  {
    value:
      'Par (p) – a natural person in respect of a dividend paid on or after 1 March 2015, for a Tax-Free Savings Account',
    key: 'exemptReasonParP',
  },
];
